module.exports = __webpack_public_path__ + "img/20191023164622043.a11d39fd.jpg";